<template>
    <form
        class="form-container bg-white"
        :data-vv-scope="'step_' + activeStep"
        @submit.prevent="checkRegisterForm('step_' + activeStep)">
        <!-- header -->
        <div class="form-container-header">
            <div class="form-title">
                <div class="form-title-title">{{ steps[activeStep-1].title }}</div>
                <ul class="pagination-nav">
                    <li v-for="(item, index) in steps"
                        :class="{'active': activeStep === index+1}"
                        :key="index">
                        <a>{{ index + 1 }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- steps body -->
        <div class="form-container-body" v-if="activeStep === 1">
            <div class="form-group">
                <input type="email"
                       name="user_email"
                       v-model='step1.email'
                       v-validate='"required|email"'
                       :class="{'is-danger': errors.has('step_1.user_email') }"
                       class="form-control"
                       :placeholder="'E-mail'">
            </div>
            <div class="form-row">
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <input type="password"
                               name="user_password"
                               v-model='step1.password'
                               ref="user_password"
                               v-validate='"required|min:6|max:32"'
                               :class="{'is-danger': errors.has('step_1.user_password') }"
                               class="form-control"
                               :placeholder="'Password'">
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="form-group">
                        <input type="password"
                               name="user_password_confirm"
                               v-model='step1.passwordConfirm'
                               v-validate='"required|confirmed:user_password"'
                               :class="{'is-danger': errors.has('step_1.user_password_confirm') }"
                               class="form-control"
                               :placeholder="'Confirm password'">
                    </div>
                </div>
            </div>
        </div>

        <div class="form-container-body" v-if="activeStep === 2">
            <div class="form-group-wrapper">
                <div class="form-group-title" v-html="'user information'"></div>
                <div class="form-row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="user_first_name"
                                   v-model='step2.firstName'
                                   v-validate='"required"'
                                   :class="{'is-danger': errors.has('step_2.user_first_name') }"
                                   class="form-control"
                                   :placeholder="'Name'">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="user_last_name"
                                   v-model='step2.lastName'
                                   v-validate='"required"'
                                   :class="{'is-danger': errors.has('step_2.user_last_name') }"
                                   class="form-control"
                                   :placeholder="'Surname'">
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="user_phone"
                                   v-model='step2.phone'
                                   v-validate='{required: true, numeric: true }'
                                   :class="{'is-danger': errors.has('step_2.user_phone') }"
                                   class="form-control"
                                   :placeholder="'Phone number'">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="email"
                                   name="user_email"
                                   v-model='step1.email'
                                   v-validate='"required|email"'
                                   :class="{'is-danger': errors.has('step_2.user_email') }"
                                   class="form-control"
                                   :placeholder="'Petras@petrita.l'">
                        </div>
                    </div>
                </div>
            </div>
            <hr>

            <div class="form-group-wrapper">
                <div class="form-group-title" v-html="'Company information'"></div>
                <div class="form-row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="company_name"
                                   v-model='step2.company.name'
                                   class="form-control"
                                   :placeholder="'Company name'"
                                   @keyup.delete="resetCampaignData()">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="company_code"
                                   v-model='step2.company.code'
                                   class="form-control"
                                   :placeholder="'Company code'"
                                   v-if="step2.company.name"
                            >
                        </div>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="company_vat"
                                   v-model='step2.company.VAT'
                                   class="form-control"
                                   :placeholder="'Company VAT no.'"
                                   v-if="step2.company.name">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <div class="form-group">
                            <input type="text"
                                   name="company_address"
                                   v-model='step2.company.address'
                                   class="form-control"
                                   :placeholder="'Company address'"
                                   v-if="step2.company.name">
                        </div>
                    </div>
                </div>
                <hr>
                <div class="form-group-title" v-html="'How did you find out about Boxiti?'"></div>
                <v-select
                    class="v-select-user register-select"
                    v-model="step2.informationSource"
                    name="information_source"
                    label="nameEn"
                    :options="informationSourceOptions"
                    :clearable="false"
                    :searchable="false"
                    v-validate="'required'"
                    placeholder="Choose"
                    :class="{'is-danger': errors.has('step_2.information_source')}"
                >
                </v-select>
            </div>
        </div>

        <div class="form-container-body" v-if="activeStep === 3">
            <div class="row justify-content-between">
                <div class="col-12 col-sm-6">
                    <div class="range-container">
                        <div class="range-container-title" v-html="'How much SKU do you plan <br>to store?'"></div>
                        <div class="range-container-output">{{step3.planningSKU}}</div>
                        <vue-slider v-bind="optionsVueSlider"
                                    v-model="step3.planningSKU"
                                    :data="vueSliderData"/>
                        <div class="range-container-description"
                             v-html="'Drag the bar to indicate the quantity of goods you\'re planning to store'"></div>
                    </div>
                </div>
                <div class="col-12 col-sm-6">
                    <div class="range-container">
                        <div class="range-container-title" v-html="'Estimated monthly <br> orders'"></div>
                        <div class="range-container-output">{{step3.approximateOrderQuantity}}</div>
                        <vue-slider v-bind="optionsVueSlider"
                                    v-model="step3.approximateOrderQuantity"
                                    :data="vueSliderData"/>
                        <div class="range-container-description"
                             v-html="'Drag the bar to indicate how many orders do you have per month (approximately)'"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="form-container-footer">
            <div class="w100" v-if="activeStep === 3">
                <div class="form-check form-check-inline">
                    <b-form-checkbox name="terms"
                                     v-model='step3.terms'
                                     v-validate='"required"'
                                     required
                                     :class="{'is-danger': errors.has('step_3.terms') }">
                        I have read and agree to
                        <a v-b-modal="'privacy-policy-modal'">Privacy policy</a>
                    </b-form-checkbox>
                </div>
            </div>
            <div class="w-100">
                <div
                    class="is-danger-color"
                    v-if="registerFormErrors.show">
                    <span v-if="registerFormErrors.status">{{ registerFormErrors.status }} - </span>
                    {{ registerFormErrors.title }}
                    <div v-if="registerFormErrors.errors.length"
                         v-for="(error, index) in registerFormErrors.errors"
                         :key="index">
                        {{ error.message }}
                    </div>
                </div>
            </div>
            <div>&nbsp;</div>
            <div class="button-wrapper">
                <b-btn variant="link"
                       v-show="activeStep !== 1"
                       @click="goToPrevStep()"
                       v-html="'back'"></b-btn>
                <b-btn type="submit"
                       :key="activeStep"
                       :class="buttonClass"
                       :disabled="buttonLoader"
                >
                        {{ steps[activeStep-1].submitText }}
                        <span v-if="buttonLoader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </b-btn>
            </div>
        </div>

        <b-modal
            id="privacy-policy-modal"
            title="Privacy policy"
            scrollable
            ok-only
            ok-title="Cancel"
            ok-variant="secondary"
            size="xl"
        >
            <privacy-policy-content></privacy-policy-content>
        </b-modal>
    </form>

</template>

<script>
    import SocialButton from '../Social/SocialButton/SocialButton.vue'
    import PrivacyPolicyContent from '~cp/PrivacyPolicyContent'
    import vueSlider from 'vue-slider-component'
    import axios from 'axios'

    export default {
        name: 'register',
        components: {
            SocialButton,
            PrivacyPolicyContent,
            vueSlider
        },
        data() {
            return {
                buttonLoader: false,
                steps: [
                    {title: 'Create your Boxiti account', submitText: 'Next'},
                    {title: 'Contact information', submitText: 'Next'},
                    {title: 'Additional information', submitText: 'CREATE ACCOUNT'}
                ],

                optionsVueSlider: {
                    tooltip: false,
                    height: 3,
                    dotSize: 23,
                    style: {
                        'marginBottom': '30px',
                        'marginTop': '10px',
                        'padding': '0'
                    },
                    bgStyle: {
                        'backgroundColor': '#c7c7c7'
                    },
                    sliderStyle: {
                        'backgroundColor': '#2dd8fb',
                        'border': '5px solid white',
                        'boxShadow': '0 0 20px rgba(56, 53, 54, 0.2)'
                    },
                    processStyle: {
                        'backgroundColor': '#2dd8fb'
                    },
                },
                vueSliderData: [ '0', '0-100', '101-200', '201-300', 'over 300' ],

                step1: {
                    email: '',
                    password: '',
                    passwordConfirm: ''
                },

                step2: {
                    firstName: '',
                    lastName: '',
                    phone: '',
                    company: {
                        name: '',
                        code: '',
                        VAT: '',
                        address: '',
                        // url: ''
                    },
                    informationSource: null
                },

                informationSourceOptions: [
                    'Online search (Google, Bing, Yahoo, etc.)',
                    'Social networks (Facebook, Instagram, LinkedIn, etc.)',
                    'Recommendations',
                    'Other'
                ],

                step3: {
                    planningSKU: 0,
                    approximateOrderQuantity: 0,
                    terms: false
                },

                activeStep: 1,

                registerFormErrors: {
                    show: false,
                    status: 0,
                    title: '',
                    errors: []
                }
            }
        },
        computed: {
            availableStep2() {
                return this.step1.email !== '' && this.step1.password !== '' && this.step1.passwordConfirm !== '' && this.errors.items.length === 0
            },
            availableStep3() {
                return this.step2.firstName !== '' && this.step2.lastName !== '' && this.step2.phone !== '' && this.step2.informationSource !== null && this.errors.items.length === 0
            },
            buttonClass() {
                switch (this.activeStep) {
                    case 1:
                        return this.availableStep2 ? 'btn-primary-user' : 'btn-secondary'
                    case 2:
                        return this.availableStep3 ? 'btn-primary-user' : 'btn-secondary'
                    case 3:
                        return this.step3.terms ? 'btn-primary-user' : 'btn-secondary'
                }
            }
        },
        methods: {
            resetCampaignData() {
                this.step2.company.name = ''
                this.step2.company.VAT = ''
                this.step2.company.code = ''
                this.step2.company.address = ''
            },

            checkEmail() {
                this.buttonLoader = true
                axios({
                    method: 'GET',
                    url: this.$endpoints.checkEmail + '?email=' + this.step1.email,
                    headers: {'Authorization': null}
                }).then((response) => {
                    this.setErrors({}, false)
                    this.goToNextStep()
                }).catch((error) => {
                    if (error.response.data.status === 400) {
                        this.setErrors({title: 'This email address is already exist'}, true)
                    }
                }).finally(() => {
                    this.buttonLoader = false
                })
            },

            checkRegisterForm(scope) {
                this.$validator.validateAll(scope).then((result) => {
                    if (result) {
                        switch (this.activeStep) {
                            case 1:
                                this.checkEmail()
                                break
                            case 2:
                                this.goToNextStep()
                                break
                            case 3:
                                this.submitRegisterForm()
                        }
                    }
                })
            },

            goToNextStep() {
                this.activeStep++
            },

            goToPrevStep() {
                this.activeStep--
            },

            setErrors(data, show) {
                this.registerFormErrors.status = data ? data.status : ''
                this.registerFormErrors.title = data ? data.title : ''
                this.registerFormErrors.errors = data ? data.errors : []
                this.registerFormErrors.show = show
            },

            submitRegisterForm() {
                let body = {
                    email: this.step1.email,
                    password: this.step1.password,
                    phone: this.step2.phone,
                    firstName: this.step2.firstName,
                    lastName: this.step2.lastName,
                    company: this.step2.company,
                    informationSource: this.step2.informationSource,
                    planningSKU: /over/.test(this.step3.planningSKU) ? 'over_300' : this.step3.planningSKU,
                    approximateOrderQuantity: /over/.test(this.step3.approximateOrderQuantity) ? 'over_300' : this.step3.approximateOrderQuantity,
                    facebookId: null,
                    googleId: null
                }
                this.buttonLoader = true
                axios({
                    method: 'POST',
                    url: this.$endpoints.register,
                    data: body,
                    headers: {'Authorization': null}
                }).then((response) => {
                    this.$store.dispatch('globalAlertAction', {
                        type: 'success',
                        message: 'Your Boxiti account is created successfully, please login',
                        timeout: 6000
                    })
                    this.setErrors({}, false)
                    this.$router.push({name: 'login'})
                }).catch((error) => {
                    this.setErrors(error.response.data, true)
                }).finally(() => {
                    this.buttonLoader = false
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Authentication/Register/Register.vue